import { render, staticRenderFns } from "./SettingsLicenseText.vue?vue&type=template&id=3ee6c26a&"
import script from "./SettingsLicenseText.vue?vue&type=script&lang=js&"
export * from "./SettingsLicenseText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports